// ================================================================================
// site-menu.js
// ハンバーガーメニュー用のスクリプトファイル
// ================================================================================

export default function siteMenu() {

	let dropDownButton = document.querySelectorAll('.js-mobile-menu');

	let menuOpenTarget = document.querySelector('body');

	if ( dropDownButton ) {
		for ( let i = 0; i < dropDownButton.length; i++ ) {
			dropDownButton[i].addEventListener('click', () => {
				dropDownButton[i].classList.toggle('is-close');
				menuOpenTarget.classList.toggle('is-menu-open');
			} );
		}
	}

	// barba.js の関係からハンバーガーメニュークリック時はメニューを閉じる
	let dropDownLink = document.querySelectorAll('.site-menu-item__link');

	for ( let i = 0; i < dropDownLink.length; i++ ) {
		dropDownLink[i].addEventListener('click', () => {
			for ( let i = 0; i < dropDownButton.length; i++ ) {
				dropDownButton[i].classList.toggle('is-close');
			}
			menuOpenTarget.classList.toggle('is-menu-open');
		});
	}

}
